const initDesignCenterFinder = () => {
    const root = document.querySelector("[data-design-centers]");
    if (!root) return;

    const select = root.querySelector("[data-design-center-select]");
    const resultCol = root.querySelector("[data-design-center-result]");
    const results = Array.from(root.querySelectorAll("[data-design-center]"));
    if (!select || !resultCol || !results.length) return;

    select.addEventListener("change", () => {
        const value = select.value;
        results.forEach((result) => {
            result.classList.toggle("is-hidden", result.dataset.designCenter !== value);
        });
        resultCol.classList.toggle("is-hidden", value === "");
    });
};

initDesignCenterFinder();
